import React from 'react';
import { Box, Flex, HStack } from '@chakra-ui/react';
import { KDrawerFooterProps } from '../KDrawer.types';

// this is a template, based on design system, add different footers to use

export const KDrawerFooter = ({
  primaryButton,
  secondaryButton,
  leftItems,
  rightItems,
}: KDrawerFooterProps) => {
  return (
    <Flex justify="space-between" align="center" width="100%">
      {leftItems && <Box>{leftItems}</Box>}
      <HStack spacing={4} {...(!leftItems ? { ml: 'auto' } : {})}>
        {secondaryButton}
        {primaryButton}
      </HStack>
      {rightItems && <Box>{rightItems}</Box>}
    </Flex>
  );
};
